<template>
    <Sidebar v-if="store.state.user_data"/>
    <Content class="creator-list-content">
        <Loading class="static static-back" v-show="is_loading || store.state.is_loading"/>

        <div class="inner inner-box" v-if="(!store.state.is_loading && !is_loading) && (data.length > 0 || ( data.length === 0 && !is_empty_data)) && can_see_pro">
            <Header @create="createPro"/>

            <div class="applic-data-wrap" >

                <header class="top">
                    <div class="left">
                        <Dropdown v-if="!is_loading" :items="filterList"  class="dropdown-status"
                        :default_value="filter_value[0].index" @update-dropdown="updateFilter" />

                        <Dropdown :items="programs" :disabled="programs.length === 0"  class="dropdown-programs"
                        @update-dropdown="updateProgram" :is_update_index="true"
                        :default_value="0"
                        :is_select_dropdown="true" />

                        <Dropdown :items="typeFilterList" class="dropdown-type"
                        @update-dropdown="updateTypeFilter" :default_value="0" v-if="!link_only"/>
                    </div>
                    <div class="ui-search">
                        <Search @onenter="search" :placeholder_text="'Search by program name, URL, or tag'"/>
                    </div>
                    <div class="right">
                        <Dropdown :items="select_pagenum" @update-dropdown="updatePagenum" :default_id="sort.per_page"/>
                        <Pagenavi :page_current="sort.current_page" :page_total="sort.total_page"
                            @goto-page="gotoPage" />
                    </div>
                </header>
                <Scrollbar class="data-list" :show_bar="true">
                    <Table :style="top" :class="{ 'is-loading': is_loading_data }">
                        <template #head>
                                <TableTh :name="'name'" :title="'Application Title'" :sort_value="sort"
                                            @sort="sortFun" :content="'Application Title'" />
                                <TableTh :name="'status'" :title="'Status'" :sort_value="sort"
                                @sort="sortFun" :content="'Status'" />
                                <!-- <th><span>Social(s)</span></th> -->
                                <TableTh :name="'approved'" :title="'Approved'" :sort_value="sort"
                                @sort="sortFun" :content="'Approved'" />
                                <TableTh :name="'todo'" :title="'To-Do'" :sort_value="sort"
                                @sort="sortFun" :content="'To-Do'" />
                                <TableTh :name="'waitlist'" :title="'Waitlist'" :sort_value="sort"
                                @sort="sortFun" :content="'Waitlist'" />
                                <TableTh :name="'candidates'" :title="'Candidates'" :sort_value="sort"
                                @sort="sortFun" :content="'Candidates'" />
                                <TableTh v-if="!link_only" :name="'account_type'" :title="'Account Type'" :sort_value="sort"
                                @sort="sortFun" :content="'Account Type'" />
                                <th>Application Period</th>
                                <!-- <TableTh :name="'application_start'" :title="'Application Period'" :sort_value="sort" @sort="sortFun" :content="'Application Period'" />-->
                                <TableTh :name="'program_tag'" :title="'Application Tag'" :sort_value="sort"
                                @sort="sortFun" :content="'Applicants approved to activate storefronts will be automatically labeled with this tag, viewable in the Creator Management dashboard.'" />
                                <th></th>
                                <th></th>
                        </template>

                        <template #body>
                            <template v-if="!is_loading && !store.state.is_loading && data.length === 0 && !is_empty_data">
                                <tr>
                                    <td colspan="13">
                                        <NoData />
                                    </td>
                                </tr>
                            </template>

                            <tr v-for="(row, index) in data" :key="index" @click="open(row)" :class="['status-' + row.status_name]">

                                <td class="name td">
                                    <div class="title">
                                        <tippy :content="row.title"
                                            @mouseover="isEllipsisActive($event, row)">
                                            {{ row.title }}
                                        </tippy>
                                    </div>
                                    <tippy :content="row.url"
                                        @mouseover="isEllipsisActive($event, row)">
                                        <a :href="row.url" target="_blank">{{ row.url }}</a>
                                    </tippy>
                                </td>
                                <td class="badage td">
                                    <Badage :value="row.stateValue.text" :type="row.stateValue.color" />
                                </td>
                                <td class="value td" v-for="(v, k) in row.list" :key="k">
                                    <!-- <div class="v-title">{{v.name}}</div> -->
                                    <div class="v-value" style="justify-content: unset;">
                                        <span v-if="v.value === '---'" class="none">---</span>
                                        <span v-else-if="v.value === '--- (0%)'" class="none">--- (0%)</span>
                                        <span v-else>{{v.value}}</span>
                                        <span class="v-is-new" v-if="v.new && v.new!=='---'"><svg-icon name="plus"/>{{v.new}}</span>
                                    </div>
                                </td>
                                <!-- new todo-->
                                <td class="value td" v-if="!link_only">
                                    <div class="v-value">{{ row.account_type === 'flexible' ? 'Both' : row.account_type === 'shortlink' ? 'Links' : (row.account_type ? row.account_type.charAt(0).toUpperCase() + row.account_type.slice(1) : '---') }}</div>
                                </td>
                                <td class="value td">
                                    <div class="v-value">{{ row.period }}</div>
                                </td>
                                <td class="value tag-td td">
                                    <tippy :content="row.tag" @mouseover="isEllipsisActive($event, row)">
                                        <Badage :value="row.tag" :type="'gray'" />
                                    </tippy>
                                </td>
                                <td class="item-btn td">
                                    <el-button v-if="row.btn === 'Responses' && permission_recruitment.manageCandidates.permission !== 0"
                                        class="res-btn" size="small" @click.stop="listPick(row.status, row)">
                                        {{ row.btn }}
                                    </el-button>

                                    <el-button v-else-if="row.btn === 'Edit'"
                                        class="edit-btn" size="small" @click.stop="listPick(row.status, row)">
                                        {{ row.btn }}
                                    </el-button>
                                </td>
                                <td :class="['item td three-td', store.state.merchant_disabeld && 'disabeld-box']" @click.stop>
                                    <el-dropdown trigger="click" @command="(id) => selectType(id, row)" placement="bottom-end">
                                        <span class="three-dot-trigger"><svg-icon name="menu" /></span>
                                        <template #dropdown>
                                            <el-dropdown-menu>
                                                <el-dropdown-item
                                                    v-for="(item, idx) in getEditList(row)"
                                                    :key="idx"
                                                    :command="item.id"
                                                    :class="{ red: item.id === 8 }">
                                                    {{ item.text }}
                                                </el-dropdown-item>
                                            </el-dropdown-menu>
                                        </template>
                                    </el-dropdown>
                                </td>
                            </tr>
                        </template>

                    </Table>
                </Scrollbar>
            </div>
        </div>

        <!-- empty-list -->
        <Empty @create="createPro" v-if="(data.length === 0 && is_empty_data || !can_see_pro) && !store.state.is_loading && !is_loading">
            <Header :had_programs="false"/>
        </Empty>
    </Content>

    <AddProgramPop ref="add" @save="goOpenSet"/>

    <Modal :is_show="is_show_add_modal" class="add-creator-modal" @click-bg="is_show_add_modal = false">
        <header>Add Creators <i @click="is_show_add_modal = false"><svg-icon name="close" /></i></header>
    </Modal>

    <Modal :is_show="is_show_del_modal" class="alert-modal" @click-bg="is_show_del_modal = false">
        <div class="box">
            <header class="delete-header">Delete application?</header>
            <p>You will lose access to all candidate information and responses if you choose to delete this application. You can stop accepting submissions in your Applications dashboard.</p>
            <div class="btns">
                <el-button size="small" @click="is_show_del_modal = false">Don't delete</el-button>
                <el-button class="modal-del-btn" size="small" type="danger" @click="isDel()">Delete</el-button>
            </div>
        </div>
    </Modal>

    <Modal :is_show="is_show_error_modal" class="alert-modal" @click-bg="is_show_error_modal = false">
        <div class="box">
            <header class="delete-header">Submission error</header>
            <p>Please review and complete the required field(s):</p>
            <ul style="margin: 16px 16px 16px 24px; color: var(--black-60)">
                <li style="list-style: disc;" v-for="(item, index) in error_messages" :key="index">{{ item.message }}</li>
            </ul>
            <div class="btns">
                <el-button size="small" type="primary" @click="is_show_error_modal = false; store.state.is_loading = true; openFormSetting(null, 'edit', error_id)">Edit application</el-button>
            </div>
        </div>
    </Modal>

    <ApplicationPublishModal ref="pub_modal" :url="current_app_url" />
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { ElButton, ElDropdown, ElDropdownMenu, ElDropdownItem } from 'element-plus';
import Sidebar from '@/components/Sidebar.vue';
import Content from '@/components/ui/Content.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Modal from '@/components/ui/Modal.vue';
import Header from '@/components/programs/ApplicationsListHeader.vue';
import Badage from '@/components/ui/Badage.vue';
import Table from '@/components/ui/Table.vue';
import Loading from '@/components/ui/Loading.vue';
import NoData from '@/components/creator/NoData.vue';
import Empty from '@/components/programs/ApplicationsListEmpty.vue';
import AddProgramPop from '@/components/programs/AddProgramPop.vue';
import Dropdown from '@/components/ui/Dropdown.vue';
import TableTh from '@/components/ui/TableTh.vue';
import Search from '@/components/ui/Search.vue';
import Pagenavi from '@/components/ui/Pagenavi.vue';
import moment from 'moment';
import { HandleNum, HandleNumSpec } from '@/utils/SwitchFun';
import { appDropList1, appDropList2, appDropList3, FilterList } from '@/utils/ProgramsData.js';
import ApplicationPublishModal from '@/components/programs/ApplicationPublishModal.vue';

const store  = useStore();
const router = useRouter();
const route  = useRoute();
const { proxy } = getCurrentInstance();

// ─── template refs ────────────────────────────────────────────────
const add       = ref(null);
const pub_modal = ref(null);

// ─── state ────────────────────────────────────────────────────────
const is_loading          = ref(true);
const is_loading_data     = ref(false);
const is_show_add_modal   = ref(false);
const is_show_del_modal   = ref(false);
const is_show_error_modal = ref(false);
const error_messages      = ref([]);
const error_id            = ref(0);
const current_app_url     = ref('');
const data                = ref([]);
const filter_value        = ref([
    { field_name: 'program_status', value: '', index: 0 },
    { field_name: 'program_tag',    value: '' },
    { field_name: 'account_type',   value: '' },
]);
const typeFilterList = ref([
    { key: '',   text: 'All' },
    { key: 'flexible',   text: 'Both' },
    { key: 'storefront', text: 'Storefront' },
    { key: 'shortlink',  text: 'Links' },
]);
const sort = reactive({
    sort_key:       '',
    sort_val:       'desc',
    per_page:       50,
    search_keyword: '',
    current_page:   1,
    total_page:     1,
});
const select_pagenum = ref([
    { id: 50, text: '50/page' },
    { id: 20, text: '20/page' },
]);
const programs       = ref([{ id: 1, text: 'All', is_selected: true }]);
const filterList     = ref(FilterList);
const top            = ref('--top: 0px');
const now_pick_row   = ref({});
const is_user_filter = ref(false); //上方操作時會讓data操控瞬間為0，導致UI體感不好，這邊做handle

// ─── computed ─────────────────────────────────────────────────────
//在沒任何條件篩選下真的空的Data
const is_empty_data = computed(() =>
    !filter_value.value[0].value && !filter_value.value[1].value &&
    !sort.search_keyword && !sort.sort_key && !is_user_filter.value
);

const can_see_pro = computed(() => {
    const user_d = store.state.user_data;
    return user_d && user_d.merchant_account && user_d.merchant_account.is_enable_ambassador_program;
});

const permission_recruitment = computed(() =>
    store.state.user_data?.permission_list?.recruitment
);

const link_only = computed(()=> {
    return store.state.user_data?.merchant_account?.platform_type === 'linkonly';
});
// ─── methods ──────────────────────────────────────────────────────
const open = (row) => {
    if (row.status_name !== 'draft' && permission_recruitment.value.manageCandidates.permission !== 0) {
        router.push(`/programs/application/${row.ambassador_application_id}`);
    } else if (row.status_name === 'draft') {
        openFormSetting(null, 'edit', row.ambassador_application_id);
    }
};

const isEllipsisActive = (e, row) => {
    row.is_ellipsis_active = e.target.offsetWidth < e.target.scrollWidth;
};

// 根據 row.status 組合對應的 dropdown 選單，並套用 permission 過濾
const getEditList = (row) => {
    let list;
    if (row.status === 50)     list = [...appDropList2];
    else if (row.status === 0) list = [...appDropList3];
    else                       list = [...appDropList1];

    if (!permission_recruitment.value?.editApplicationSettings?.permission) {
        list = list.filter(item => item.id === 1 || item.id === 5);
    }
    return list;
};

const openFormSetting = (createData, type, id, is_preview) => {
    store.state.program_data.create_data = createData;
    store.state.program_data.is_preview  = is_preview ? true : false;
    router.push(`/programs/application/${type}/${id}`);
};

const listPick = (status, row) => {
    if (status === 50) {
        openFormSetting(null, 'edit', row.ambassador_application_id);
    } else {
        open(row);
    }
};

const selectType = (id, row) => {
    now_pick_row.value = row;
    const aId = row.ambassador_application_id;

    if (id === 1) {
        store.state.is_loading = true;
        openFormSetting(null, 'edit', aId, 'preview');
    } else if (id === 2) {
        window.open(row.url, '_blank');
    } else if (id === 3) {
        store.state.is_loading = true;
        openFormSetting(null, 'edit', aId);
    } else if (id === 4) {
        store.state.is_loading = true;
    } else if (id === 5) {
        proxy.EventBus.emit('open-share', { storefront_url: row.url });
    } else if (id === 6) {
        store.state.is_loading = true;
        proxy.$ajax('/ambassador/unpublished-application', { method: 'post', data: { application_id: aId } })
            .then(() => {
                is_user_filter.value = true;
                fetchData();
                proxy.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Unpublish success!`);
                store.state.is_loading = false;
            })
            .catch(err => handleErrMes(err));
    } else if (id === 7) {
        publishApplication(aId);
    } else if (id === 8) {
        //目前只有草稿在這裡可以刪除，所以就不提示警告
        isDel(row);
    } else if (id === 9) {
        store.state.is_loading = true;
        proxy.$ajax('/ambassador/republish-application', { method: 'post', data: { application_id: aId } })
            .then(() => {
                is_user_filter.value = true;
                fetchData();
                proxy.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Republish success!`);
                store.state.is_loading = false;
            })
            .catch(err => handleErrMes(err));
    }
};

const isDel = (row) => {
    const targetRow = row || now_pick_row.value;
    store.state.is_loading = true;
    const aId = targetRow.ambassador_application_id;
    proxy.$ajax('/ambassador/delete-application', { method: 'post', data: { application_id: aId } })
        .then(() => {
            const idx = data.value.findIndex(item => item.ambassador_application_id === aId);
            data.value.splice(idx, 1);
            store.state.is_loading = false;
            proxy.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Delete Success!`);
        })
        .catch(err => handleErrMes(err));
};

const publishApplication = (aId) => {
    store.state.is_loading = true;
    proxy.$ajax('/ambassador/publish-application', { method: 'post', data: { application_id: aId } })
        .then(() => {
            is_user_filter.value  = true;
            current_app_url.value = data.value.find(item => item.ambassador_application_id === aId).url;
            fetchData();
            store.state.is_loading = false;
            pub_modal.value.open();
        })
        .catch(err => {
            store.state.is_loading    = false;
            is_show_error_modal.value = true;
            error_id.value            = aId;
            error_messages.value      = err.response.data.data.message;
        });
};

const handleErrMes = (err) => {
    if (err.response?.data?.message) {
        proxy.$notify(`<svg class="err-notify"><use xlink:href="#alert--sprite"></use></svg> ${err.response.data.message}!`);
    } else if (err.response?.data?.data?.message) {
        proxy.$notify(`<svg class="err-notify"><use xlink:href="#alert--sprite"></use></svg> ${err.response.data.data.message}!`);
    }
    store.state.is_loading = false;
};

const resetSort = () => {
    sort.sort_key     = '';
    sort.sort_val     = 'desc';
    sort.current_page = 1;
};

const search = (keyword) => {
    resetSort();
    is_user_filter.value  = true;
    sort.search_keyword = keyword;
    fetchData();
};

const updateTypeFilter = (val) => {
    is_user_filter.value = true;
    resetSort();
    filter_value.value[2].value = val.key;
    fetchData();
};

const updateFilter = (val) => {
    is_user_filter.value     = true;
    resetSort();
    filter_value.value[0].value = val.key;
    filter_value.value[0].index = val.index_key;
    fetchData();
};

const updateProgram = (obj) => {
    is_user_filter.value = true;
    resetSort();
    programs.value.forEach(item => { item.is_selected = item.id === obj.id; });
    const selectedText = programs.value.find(p => p.is_selected)?.text ?? null;
    filter_value.value[1].value = (selectedText && selectedText !== 'All') ? selectedText : '';
    fetchData();
};

const updatePagenum = (obj) => {
    is_user_filter.value = true;
    sort.current_page = 1;
    sort.per_page     = obj.id;
    fetchData();
};

const gotoPage = (page) => {
    sort.current_page = page;
    fetchData();
};

const sortFun = (key) => {
    if (key === sort.sort_key) {
        sort.sort_val = sort.sort_val === 'asc' ? 'desc' : 'asc';
    } else {
        sort.sort_key = key;
        sort.sort_val = 'asc';
    }
    sort.current_page = 1;
    fetchData();
};

const makeFilter = () => {
    const filter_val = [];
    const f1 = filter_value.value[0];
    if (f1.value) filter_val.push({ field_name: f1.field_name, value: f1.value });
    const f2 = filter_value.value[1];
    if (f2.value) filter_val.push({ field_name: f2.field_name, value: f2.value });
    const f3 = filter_value.value[2];
    if (f3.value) filter_val.push({ field_name: f3.field_name, value: f3.value });

    const params_data = {
        page:     sort.current_page,
        per_page: sort.per_page,
        keyword:  sort.search_keyword,
        filters:  JSON.stringify(filter_val),
    };
    if (sort.sort_key) {
        params_data.sort_key = sort.sort_key;
        params_data.sort_val = sort.sort_val;
    }
    return params_data;
};

const fetchData = () => {
    if (!is_loading.value) is_loading_data.value = true;
    data.value = [];
    proxy.$ajax('/ambassador/list', { params: makeFilter(), method: 'get' })
        .then(res => {
            const statusMap = {
                100: { text: 'Active',    color: 'act', btn: 'Responses', status_name: 'active' },
                80:  { text: 'Scheduled', color: 'sch', btn: 'Responses', status_name: 'scheduled' },
                50:  { text: 'Draft',     color: 'dis', btn: 'Edit',      status_name: 'draft' },
                0:   { text: 'Closed',    color: 'clo', btn: 'Responses', status_name: 'closed' },
            };
            res.data.data.data.forEach(item => {
                const appRate = HandleNumSpec(item.approved_rate) === '---' ? '' : `(${HandleNumSpec(item.approved_rate)}%)`;
                item.list = [
                    { name: 'Approved',   value: `${HandleNum(item.approved)} ${appRate}` },
                    { name: 'To-Do',      value: HandleNum(item.todo) },
                    { name: 'Waitlist',   value: HandleNum(item.waitlist) },
                    { name: 'Candidates', value: HandleNum(item.candidates), new: HandleNum(item.new_candidates) },
                ];
                const toSetDate = (start, end) => {
                    // console.log(item.status, start, end)
                    const hsdate = start === '0000-00-00 00:00:00' ? '' : moment(start).format('MM/DD/YY ');
                    const hedate = end   === '0000-00-00 00:00:00' ? '' : moment(end).format('MM/DD/YY ');
                    if (item.status === 100) {
                        return `${!hsdate ? moment(item.created_at).format('MM/DD/YY ') : hsdate} - ${!hedate ? 'Open' : hedate}`;
                    } 
                    else if (item.status === 50 && start === '0000-00-00 00:00:00' && end   === '0000-00-00 00:00:00') {
                        return `---`;
                    }
                    else {
                        return `${!hsdate ? moment(item.created_at).format('MM/DD/YY ') : hsdate} - ${hedate ? hedate : 'Open'}`;
                    }
                };
                item.period     = toSetDate(item.application_start, item.application_end);
                const statusInfo  = statusMap[item.status] || { text: '', color: '', btn: 'Responses', status_name: '' };
                item.stateValue  = { text: statusInfo.text, value: item.status, color: statusInfo.color };
                item.btn         = statusInfo.btn;
                item.tag         = item.program_tag;
                item.status_name = item.status_name || statusInfo.status_name;
                data.value.push(item);
            });
            sort.total_page       = res.data.data.last_page;
            is_user_filter.value  = false;
            is_loading.value      = false;
            is_loading_data.value = false;
            store.state.is_loading = false;
        });
};

const getTags = () => {
    programs.value = [{ id: 99999999, text: 'All', is_selected: true }];
    proxy.$ajax('/creator/get-tag-from-ambassador-list', {
        method: 'get',
        data: { merchant_account_id: store.state.user_data.merchant_account_id },
    }).then(res => {
        res.data.data.forEach(item => {
            programs.value.push({ ...item, text: item.tag, is_selected: false });
        });
    });
};

const createPro = () => { add.value.open(); };

const goOpenSet = (val) => {
    if (val.type === 'create') {
        window.localStorage.setItem('ANCHOR_program_create_data', JSON.stringify(val.val));
        openFormSetting(val.val, val.type, 1);
    }
};

// ─── watch ────────────────────────────────────────────────────────
watch(() => route.params, () => {
    data.value       = [];
    is_loading.value = true;
    fetchData();
    getTags();
}, { immediate: true });

// ─── lifecycle ────────────────────────────────────────────────────
onMounted(() => {
    if (!permission_recruitment.value.manageApplications.permission) {
        router.push({ name: 'creator--list' });
        return;
    }
    window.localStorage.removeItem('ANCHOR_program_create_data');
    if (store.state.is_show_share) {
        store.state.is_show_share = false;
    }
});
</script>

<style lang="scss">
@mixin flexCenter(){
    display: flex;
    align-items: center;
}

@mixin textOverflow(){
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
}
.creator-list-content {
    &>.inner {
        height: 100%;
        padding: 24px 48px;
        display: grid;
        grid-template-rows: auto auto 1fr;
        grid-template-columns: 100%;
        overflow: hidden;
    }

    &>.inner-empty{
        padding: 24px 32px 24px 48px;
        grid-template-rows: auto 1fr;
    }

    .loading.static {
        margin-top: 48px;
    }

    .drop-box{
        @include flexCenter();
        margin:16px 0;

        h3{
            font:var(--font-med-20);
            @include flexCenter();
            margin-right:16px;
        }
    }

    .applic-data-wrap {
        height: 100%;
        max-height: calc(100vh - 144px);
        display: grid;
        grid-template-rows: auto auto 1fr;
        grid-template-columns: 100%;
        position: relative;

        .top {
            display: flex;
            align-items: center;
            padding: 16px 0;

            .ui-search {
                flex: 1;
                padding: 0 10px;

                .ui-search-input .input {
                    max-width: unset;
                }
            }

            .left {
                display: flex;
                align-items: center;

                .ui-button {
                    display: inline-flex;
                    align-items: center;

                    .svg-icon--plus {
                        height: 10px;
                        width: 10px;
                        margin-right: 5px;
                    }
                }

                .ui-dropdown,
                .ui-filter-dropdown {
                    margin-left: 10px;

                    &:first-child{
                        margin-left: 0;
                    }
                }
            }

            .right {
                display: flex;
                align-items: center;

                .ui-dropdown {
                    margin-right: 10px;
                }

                .download-btn {
                    color: var(--black-90);
                    height: 32px;
                    width: 32px;
                    margin-left: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;

                    svg {
                        height: 16px;
                        width: 16px;
                        display: block;
                    }

                    &.disabled {
                        cursor: not-allowed;

                        svg {
                            fill: var(--black-20);
                        }
                    }
                }
            }

            .ui-dropdown {
                .ui-button {
                    border-color: var(--black-10);
                    background-color: var(--black-10);
                }
            }
        }

        .three-dot-trigger {
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            padding: 4px;
            border-radius: 4px;

            &:hover {
                background: var(--bg-02);
            }

            svg {
                height: 12px;
                width: 12px;
                display: block;
            }
        }

        .red {
            color: var(--red);
        }

        .dropdown-programs .ui-dropdown--inner {
            .ui-button span span::before  {
                content: 'Application Tag: ';
            }

            .svg-icon--arrow{
                display: none;
            }

            .scrollbar-content {
                min-width: 200px;
                max-height: 300px;

                &::before {
                    content: 'Application Tag: ';
                    display: block;
                    font: var(--font-regular-12);
                    padding: 6px 10px 0;
                    color: var(--black-50);
                    margin-bottom: 12px;
                }
            }
        }

        .dropdown-status .ui-dropdown--inner {
            .ui-button span span::before {
                content: 'Status: ';
            }

            .svg-icon--arrow{
                display: none;
            }

            .scrollbar-content {
                max-height: 300px;

                &::before {
                    content: 'Status: ';
                    display: block;
                    font: var(--font-regular-12);
                    padding: 6px 10px 0;
                    color: var(--black-50);
                    margin-bottom: 12px;
                }
            }
        }

        .dropdown-type .ui-dropdown--inner {
            .ui-button span span::before  {
                content: 'Type: ';
            }

            .svg-icon--arrow{
                display: none;
            }

            .scrollbar-content {
                min-width: 200px;
                max-height: 300px;

                &::before {
                    content: 'Type: ';
                    display: block;
                    font: var(--font-regular-12);
                    padding: 6px 10px 0;
                    color: var(--black-50);
                    margin-bottom: 12px;
                }
            }
        }

        .ui-table {
            white-space: nowrap;

            .tbody tr {
                cursor: pointer;

                // &.status-draft {
                //     cursor: default;
                // }

                .td {
                    max-width: 250px;
                    @include textOverflow;
                }

                .none {
                    color: var(--neutral-60);
                }

                .tag-td{
                    .my-badges-iden{
                        @include textOverflow;
                        max-width: 120px;
                        width: auto;
                    }
                }

                .name{
                    .title{
                        font:var(--font-med-16);
                        margin-bottom:3px;
                    }

                    a{
                        color:var(--blue);
                        font-size:12px;
                    }
                }

                .badage{
                    .my-badges-iden{
                        font:var(--font-med-10);
                    }
                }

                .value{
                    .v-title{
                        font-size:14px;
                        color:var(--black-75);
                        margin-bottom:3px;
                    }

                    .v-value{
                        font:var(--font-med-12);
                        @include flexCenter();
                        justify-content: space-between;
                    }

                    .v-is-new{
                        background: var(--red);
                        border-radius: 10px;
                        @include flexCenter();
                        color: var(--white);
                        padding: 0 6px;
                        height: 18px;
                        font-size: 10px;
                        margin-left: 6px;

                        .svg-icon{
                            width: 6px;
                            height: 6px;
                            margin-right: 2px;
                            fill: var(--white);
                        }
                    }
                }

                .item-btn{

                    .ui-button{
                        display: block;
                        padding:6px 8px;
                        height: unset;
                        box-sizing: border-box;
                        width: 100%;
                        text-align: center;

                        &:hover {
                            background: var(--bg-02);
                        }
                    }
                }


                svg {
                    height: 12px;
                    display: block;
                    width: 12px;
                }

                .three-td{
                    position: relative;
                    overflow: unset
                }
            }

            .text-ellipsis-link:hover {
                text-decoration: underline;
            }


        }

    }

    .data-list-open-scroll{
        height: 90vh;
        overflow-y: visible;
    }

}

.creator-modal {
    z-index: 999;
}

.add-creator-modal-box {
    padding: 24px;
    display: flex;
    align-items: flex-start;
}
</style>
